'use client'

import { createContext, useContext, useId, ReactNode, FC } from 'react'
import classNames from 'classnames'
import Box, { BoxProps } from 'shared/components/Box/Box'

type InputFieldContextResult = {
  id: string
  isDisabled?: boolean
  status?: 'success' | 'error'
}

const InputFieldContext = createContext<InputFieldContextResult>({
  id: '',
  isDisabled: false,
})

export const useInputField = () => useContext(InputFieldContext)

type InputFieldProps = Partial<InputFieldContextResult> &
  BoxProps<'div'> & {
    /** margin‐bottom on the focus wrapper */
    mb?: BoxProps<'div'>['mb']
    children: ReactNode
  }

const InputField: FC<InputFieldProps> = ({
  isDisabled,
  status,
  mb,
  children,
  className,
  ...props
}) => {
  const id = useId()

  return (
    <InputFieldContext.Provider value={{ id, isDisabled, status }}>
      <Box className={classNames('form-field', className)} {...props}>
        <Box as="span" mb={mb} data-disabled={isDisabled} data-status={status}>
          {children}
        </Box>
      </Box>
    </InputFieldContext.Provider>
  )
}

export { InputFieldContext }
export default InputField
